import { useRouterState } from "@tanstack/react-router";
import {
    BrowserEdges,
    blendAtTop,
    type EdgePalette,
} from "@wags/ui/browser-edges.tsx";
import { EDGE_COLORS } from "@wags/ui/edge-color.ts";
import type { RefObject } from "react";
import { matchesRoutePrefix } from "./shell-navigation-layout";

type RouteEdges = EdgePalette & { blendTopIntoFooter?: true };

const MALTESE_WHITE = {
    top: EDGE_COLORS.malteseWhite,
    bottom: EDGE_COLORS.malteseWhite,
};
const TRUE_WHITE = {
    top: EDGE_COLORS.trueWhite,
    bottom: EDGE_COLORS.trueWhite,
};

const ROUTE_EDGES: ReadonlyArray<readonly [string, RouteEdges]> = [
    ["/kennel/sign-in", TRUE_WHITE],
    ["/kennel/claim", TRUE_WHITE],
    ["/journey", MALTESE_WHITE],
    [
        "/match",
        { top: EDGE_COLORS.dobermanBlack, bottom: EDGE_COLORS.malteseWhite },
    ],
    ["/discover", TRUE_WHITE],
    ["/faq", TRUE_WHITE],
    ["/kits-search", { ...TRUE_WHITE, blendTopIntoFooter: true }],
    ["/kits", { ...TRUE_WHITE, blendTopIntoFooter: true }],
    ["/explore", MALTESE_WHITE],
    ["/about", MALTESE_WHITE],
    ["/ethos", MALTESE_WHITE],
    ["/values", MALTESE_WHITE],
    ["/privacy", { ...MALTESE_WHITE, blendTopIntoFooter: true }],
    ["/terms", { ...MALTESE_WHITE, blendTopIntoFooter: true }],
    ["/saved", MALTESE_WHITE],
    ["/settings", MALTESE_WHITE],
    ["/profile", MALTESE_WHITE],
    ["/sign-in", MALTESE_WHITE],
    ["/sign-up", MALTESE_WHITE],
];

export function RouteBrowserEdges({
    footer,
}: {
    footer: RefObject<HTMLElement | null>;
}) {
    const pathname = useRouterState({
        select: (state) =>
            state.resolvedLocation?.pathname ?? state.location.pathname,
    });
    const route = ROUTE_EDGES.find(([prefix]) =>
        matchesRoutePrefix(pathname, prefix),
    )?.[1];
    if (!route) return null;
    const palette = (): EdgePalette =>
        route.blendTopIntoFooter
            ? {
                  top: blendAtTop(
                      route.top,
                      EDGE_COLORS.dobermanBlack,
                      footer.current,
                  ),
                  bottom: route.bottom,
              }
            : route;
    return <BrowserEdges layer="route" initial={route} paletteAt={palette} />;
}
